<template>
  <div>
    <table border class="index-table">
      <tr>
        <td class="index-table-label">家长姓名</td>
        <td>{{ vipInfo.userName }}</td>
        <td class="index-table-label">手机号</td>
        <td>{{ vipInfo.userPhone }}</td>
        <td class="index-table-label">会员姓名</td>
        <td>{{ vipInfo.childName }}</td>
      </tr>
      <tr>
        <td class="index-table-label">孩子小名</td>
        <td>{{ vipInfo.petName }}</td>
        <td class="index-table-label">孩子性别</td>
        <td>{{ vipInfo.gender == 0 ? '男' : '女' }}</td>
        <td class="index-table-label">生日</td>
        <td>{{ vipInfo.childBirthday }}</td>
      </tr>
      <tr>
        <td class="index-table-label">卡id</td>
        <td>{{ vipInfo.id }}</td>

        <td class="index-table-label">会员卡名称</td>
        <td>{{ vipInfo.cardName }}</td>
      </tr>
    </table>
    <el-radio-group v-model="tabPosition" style="margin: 20px 0px;" @tab-click="handleClick" @input="clickInput">
      <el-radio-button :label="0">全部</el-radio-button>
      <el-radio-button :label="1">会员跟进</el-radio-button>
      <el-radio-button :label="2">上课记录</el-radio-button>
      <el-radio-button :label="3">多媒体记录</el-radio-button>
      <el-radio-button :label="4">会前记录</el-radio-button>
    </el-radio-group>
    <div class="scroll">
    <div class="index-steps">
      <el-steps direction="vertical">
        <el-step v-for="( v, index) in getUserChInfo.clientFollowRecords" :key="v.id">
          <img v-if="index == 0" class="index-steps-icon" slot="icon" src="@/assets/icons/xa.png" alt="" />
          <img v-else class="index-steps-icon" slot="icon" src="@/assets/icons/xb.png" alt="" />
          <div slot="description">
            <p>跟进时间：{{ v.recordDateTime }} 跟进人：{{ v.followWorkerName }}</p>
            <p>跟进内容：{{ v.feedbackResult }}</p>
            <p>剩余课时: {{v.remainingClass +
                v.remainingGiveCount +
                "(" +
                v.remainingClass +
                "/" +
                v.remainingGiveCount +
                ")"}}
            </p>
            <p>客户跟进</p>
          </div>
        </el-step>
        <el-step v-for="( v, index) in getUserChInfo.multimediaList" :key="v.id">
          <img v-if="index == 0" class="index-steps-icon" slot="icon" src="@/assets/icons/xa.png" alt="" />
          <img v-else class="index-steps-icon" slot="icon" src="@/assets/icons/xb.png" alt="" />
          <div slot="description">
            <p>上传时间：{{ v.createTime }}</p>
            <!-- <p>跟进内容：{{ v.feedbackResult }}</p> -->
            <div v-if="v.type == 1">
              <p>照片：
              <div style="display: flex;flex-wrap: wrap;width: 230px;">
                <img :src="v.path" alt="" style="width: 60px;height: 60px;margin-right: 10px;margin-top: 10px;">
              </div>
              </p>
            </div>
            <div v-if="v.type == 2">
              <p>视频：
              <div>
                <!-- <video src="https://ossmeng.yyinhong.cn/common/video/Temp/20240125/aa96cc18b6bf4cdc87b806c8895ac895.mp4"></video> -->
                <video :src="v.path"
                  style="width: 320px; height: 200px" controls="controls">
                  您的浏览器不支持视频播放
                </video>
              </div>
              </p>
            </div>
            <div v-if="v.type == 3">
              <p>音频：
              <div>
                <audio controls  class="aud">
              <source :src="v.path" />
            </audio>
              </div>
              </p>
            </div>
          </div>
        </el-step>
        <el-step v-for="( v, index) in getUserChInfo.changeCardRecords" :key="v.id">
          <img v-if="index == 0" class="index-steps-icon" slot="icon" src="@/assets/icons/xa.png" alt="" />
          <img v-else class="index-steps-icon" slot="icon" src="@/assets/icons/xb.png" alt="" />
          <div slot="description">
            <!-- <p>卡名称：{{ v.oldStoreLessonCardName }}</p> -->
            <!-- <p>跟进内容：{{ v.feedbackResult }}</p> -->
            <!-- <p>扣课课时：{{ Number(v.oldCount) - Number(v.newCount) }}</p> -->
            <p>课程名：{{ v.lessonName ? v.lessonName : '' }}</p>
            <p>使用卡次：{{ v.usedTimes? v.usedTimes : '' }}</p>
            <p>签到时间：{{ v.singInTime ? v.singInTime : '' }}</p>
            <p>剩余课时: {{v.remainingClass +
                v.remainingGiveCount +
                "(" +
                v.remainingClass +
                "/" +
                v.remainingGiveCount +
                ")"}}
            </p>
          </div>
        </el-step>
      </el-steps>
    </div>
  </div>
  </div>
</template>

<script>
import {
  getUserChildFollowDetailVoById
} from "../../../api/userByCard";
import globaldata from "../../../utils/globaldata";
import {
  selectAllGET
} from '../../../api/userBookLesson';
export default {
  data() {
    return {
      tabPosition: 0,
      getUserChInfo: {},
      selectAList: []
    };
  },
  props: {
    vipInfo: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.selectA()
    console.log(this.vipInfo, 'vipInfo=========')
    this.getUserChi()
  },

  methods: {
    selectA() {
      selectAllGET({ storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.selectAList = res.data
        }
      })
    },
    getUserChi() {
      console.log(this.vipInfo, 'vipInfo')
      let param = {
        userId: this.vipInfo.userId,
        type: this.tabPosition,
        carId:this.vipInfo.id
      }
      getUserChildFollowDetailVoById(param).then((res) => {
        if (res.code == 20000) {
          this.getUserChInfo = res.data
        }
      })
    },
    clickInput(v) {
      this.tabPosition = v
      this.getUserChi()
      // console.log(v,'11111111111111')
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  &-table {
    width: 100%;
    border-collapse: collapse;
    border-color: #e4e1e1;

    tr {
      td {
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }

    &-label {
      background-color: #e9e1e1;
    }
  }
 

  &-steps {
    margin-top: 20px;

    /deep/ .el-step__description {
      color: #333333;
    }

    /deep/ .el-step__line {
      background: #b6b3b3;
    }

    &-icon {
      width: 25px;
      height: 25px;
    }

    /deep/ .el-step__icon.is-text {
      border: none;
    }
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff;
  }
}
.scroll{
    height: 400px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/vipModel.vue